import SearchIcon from '@mui/icons-material/Search';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  Menu,
  MenuItem,
  Modal,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useMediaQuery,
  Alert,
} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../../../utils/axiosInstance';

// 다크 모드 스타일 상수
const darkModeStyles = {
  container: {
    p: 2, 
    background: 'linear-gradient(180deg, rgba(25,25,38,0.95) 0%, rgba(25,32,48,0.95) 100%)',
    minHeight: '100vh'
  },
  paper: {
    p: 3,
    background: 'linear-gradient(145deg, rgba(35,35,50,0.9) 0%, rgba(35,45,65,0.85) 100%)',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
    borderRadius: '16px',
    border: '1px solid rgba(255, 255, 255, 0.08)',
    backdropFilter: 'blur(8px)',
  },
  title: {
    color: '#fff',
    fontSize: '28px',
    fontWeight: 'bold',
    letterSpacing: '0.5px',
    textShadow: '0 2px 4px rgba(0,0,0,0.3)'
  },
  textField: {
    '& .MuiInputBase-root': {
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
      borderRadius: '8px',
      color: '#fff',
      '&.Mui-disabled': {
        color: '#e0e0e0 !important', // 더 밝은 회색으로 변경하고 !important 추가
        backgroundColor: 'rgba(255, 255, 255, 0.02)', // 배경색도 약간 밝게
      }
    },
    '& .MuiInputLabel-root': {
      color: 'rgba(255, 255, 255, 0.7)',
      '&.Mui-disabled': {
        color: '#bdbdbd !important', // 라벨도 더 밝게
      }
    },
    '& .MuiOutlinedInput-input.Mui-disabled': {
      color: '#e0e0e0 !important', // input 요소에 직접 적용
      '-webkit-text-fill-color': '#e0e0e0 !important' // 웹킷 브라우저 대응
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(255, 255, 255, 0.15)'
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(255, 255, 255, 0.3)'
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#60a5fa'
    },
    '& .Mui-disabled': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(255, 255, 255, 0.1)'
      }
    }
  },
  formControl: {
    '& .MuiInputLabel-root': {
      color: 'rgba(255, 255, 255, 0.7)'
    },
    '& .MuiOutlinedInput-root': {
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
      borderRadius: '8px',
      color: '#fff'
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(255, 255, 255, 0.15)'
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(255, 255, 255, 0.3)'
    },
    '& .MuiSelect-icon': {
      color: 'rgba(255, 255, 255, 0.7)'
    }
  },
  menuItem: {
    '&.MuiMenuItem-root': {
      color: '#fff',
      backgroundColor: 'rgba(35, 35, 50, 0.95)',
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
      },
      '&.Mui-selected': {
        backgroundColor: 'rgba(96, 165, 250, 0.2)',
        '&:hover': {
          backgroundColor: 'rgba(96, 165, 250, 0.3)',
        }
      }
    }
  },
  menuItemHighlight: {
    '&.MuiMenuItem-root': {
      color: '#ce93d8',
      fontWeight: 'bold',
      backgroundColor: 'rgba(35, 35, 50, 0.95)',
      '&:hover': {
        backgroundColor: 'rgba(206, 147, 216, 0.1)',
      },
      '&.Mui-selected': {
        backgroundColor: 'rgba(206, 147, 216, 0.2)',
        '&:hover': {
          backgroundColor: 'rgba(206, 147, 216, 0.3)',
        }
      }
    }
  },
  searchButton: {
    backgroundColor: '#60a5fa',
    color: '#fff',
    borderRadius: '10px',
    padding: '10px 24px',
    boxShadow: '0 4px 10px rgba(33, 150, 243, 0.3)',
    fontWeight: 'bold',
    textTransform: 'none',
    minWidth: '120px',
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: '#3b82f6',
      boxShadow: '0 6px 12px rgba(30, 136, 229, 0.4)',
      transform: 'translateY(-2px)'
    }
  },
  createButton: {
    backgroundColor: '#9c27b0',
    color: '#fff',
    borderRadius: '10px',
    padding: '10px 24px',
    boxShadow: '0 4px 10px rgba(156, 39, 176, 0.3)',
    fontWeight: 'bold',
    textTransform: 'none',
    minWidth: '120px',
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: '#7b1fa2',
      boxShadow: '0 6px 12px rgba(156, 39, 176, 0.4)',
      transform: 'translateY(-2px)'
    }
  },
  tableContainer: {
    borderRadius: '12px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
    border: '1px solid rgba(255, 255, 255, 0.08)'
  },
  tableHead: {
    backgroundColor: 'rgba(45, 45, 65, 0.9)',
    '& .MuiTableCell-head': {
      color: '#fff',
      fontWeight: 'bold',
      borderBottom: '1px solid rgba(255, 255, 255, 0.1)'
    }
  },
  tableRow: {
    '&:nth-of-type(odd)': {
      backgroundColor: 'rgba(255, 255, 255, 0.02)'
    },
    '&:nth-of-type(even)': {
      backgroundColor: 'rgba(255, 255, 255, 0.05)'
    },
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
      transition: 'background-color 0.3s ease'
    },
    '& .MuiTableCell-body': {
      color: '#fff',
      borderBottom: '1px solid rgba(255, 255, 255, 0.05)'
    }
  },
  tableRowHighlight: {
    backgroundColor: 'rgba(156, 39, 176, 0.08)',
    '&:hover': {
      backgroundColor: 'rgba(156, 39, 176, 0.15)',
      transition: 'background-color 0.3s ease'
    },
    '& .MuiTableCell-body': {
      color: '#fff',
      borderBottom: '1px solid rgba(255, 255, 255, 0.05)'
    }
  },
  tableCell: {
    color: '#fff',
    borderBottom: '1px solid rgba(255, 255, 255, 0.05)'
  },
  loadingIndicator: {
    color: '#60a5fa',
    margin: '40px 0'
  },
  noDataMessage: {
    color: 'rgba(255, 255, 255, 0.7)',
    fontStyle: 'italic',
    padding: '40px 0'
  },
  agentButton: {
    color: '#ce93d8',
    borderColor: 'rgba(156, 39, 176, 0.5)',
    '&:hover': {
      borderColor: '#ce93d8',
      backgroundColor: 'rgba(156, 39, 176, 0.1)'
    }
  },
  addButton: {
    background: 'linear-gradient(90deg, rgba(76, 175, 80, 0.8), rgba(129, 199, 132, 0.8))',
    color: 'white',
    borderRadius: '8px',
    fontWeight: 'bold',
    textTransform: 'none',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.2)',
    padding: '6px 16px',
    '&:hover': {
      background: 'linear-gradient(90deg, rgba(67, 160, 71, 0.9), rgba(102, 187, 106, 0.9))',
      boxShadow: '0 6px 8px rgba(0, 0, 0, 0.3)',
      transform: 'translateY(-2px)'
    }
  },
  subtractButton: {
    background: 'linear-gradient(90deg, rgba(33, 150, 243, 0.8), rgba(100, 181, 246, 0.8))',
    color: 'white',
    borderRadius: '8px',
    fontWeight: 'bold',
    textTransform: 'none',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.2)',
    padding: '6px 16px',
    marginLeft: '8px',
    '&:hover': {
      background: 'linear-gradient(90deg, rgba(25, 118, 210, 0.9), rgba(66, 165, 245, 0.9))',
      boxShadow: '0 6px 8px rgba(0, 0, 0, 0.3)',
      transform: 'translateY(-2px)'
    }
  },
  treeViewButton: {
    backgroundColor: 'rgba(0, 188, 212, 0.8)',
    color: 'white',
    '&:hover': {
      backgroundColor: 'rgba(0, 188, 212, 0.95)',
    }
  },
  // 다이얼로그 스타일
  dialog: {
    '& .MuiPaper-root': {
      backgroundColor: 'rgba(35, 35, 50, 0.98)',
      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
      borderRadius: '16px',
      border: '1px solid rgba(255, 255, 255, 0.1)',
      marginTop: '32px', // 모달 자체의 상단 여백 추가
    }
  },
  dialogTitle: {
    color: '#fff',
    borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
    padding: '16px 24px'
  },
  dialogContent: {
    padding: '36px 24px',
    paddingTop: '20px', // 상단 여백 줄임
    overflow: 'visible', // 내용이 잘리지 않도록
    '& .MuiTextField-root': {
      marginBottom: '16px'
    }
  },
  dialogActions: {
    padding: '16px 24px',
    borderTop: '1px solid rgba(255, 255, 255, 0.1)',
  },
  cancelButton: {
    color: '#fff',
    borderColor: 'rgba(255, 255, 255, 0.3)',
    '&:hover': {
      borderColor: 'rgba(255, 255, 255, 0.5)',
      backgroundColor: 'rgba(255, 255, 255, 0.05)'
    }
  },
  submitButton: {
    backgroundColor: '#9c27b0',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#7b1fa2'
    },
    '&.Mui-disabled': {
      backgroundColor: 'rgba(156, 39, 176, 0.4)',
      color: 'rgba(255, 255, 255, 0.4)'
    }
  },
  // 모달 스타일
  modal: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'rgba(35, 35, 50, 0.98)',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
    p: 4,
    borderRadius: '16px',
    color: '#fff'
  },
  modalTitle: {
    color: '#fff',
    fontWeight: 'bold',
    mb: 2,
    pb: 1,
    borderBottom: '1px solid rgba(255, 255, 255, 0.1)'
  },
  // 메뉴 스타일
  menu: {
    '& .MuiPaper-root': {
      backgroundColor: 'rgba(35, 35, 50, 0.98)',
      boxShadow: '0 8px 24px rgba(0, 0, 0, 0.3)',
      borderRadius: '12px',
      border: '1px solid rgba(255, 255, 255, 0.1)',
      width: '150px',
      color: '#fff'
    },
    '& .MuiMenuItem-root': {
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.1)'
      }
    },
    '& .MuiDivider-root': {
      borderColor: 'rgba(255, 255, 255, 0.1)'
    }
  },
  menuDivider: {
    borderTop: '1px solid rgba(255, 255, 255, 0.1)',
    mt: 1,
    pt: 1
  },
  menuHeader: {
    pl: 2, 
    color: '#ce93d8', 
    fontWeight: 'bold'
  }
};

const AgentList = () => {
  const isNonMobile = useMediaQuery('(min-width:600px)');
  const navigate = useNavigate();

  const [filters, setFilters] = useState({
    agentId: '',
    userId: '',
    nickname: '',
  });

  const [anchorEl, setAnchorEl] = useState(null); // 메뉴 앵커 엘리먼트
  const [selectedAgent, setSelectedAgent] = useState(null); // 선택된 하위 에이전트
  const [upperAgentOptions, setUpperAgentOptions] = useState([]);
  const [selectedRowId, setSelectedRowId] = useState(null); // 선택된 row의 id 저장
  const [currentUser, setCurrentUser] = useState(null); // 현재 로그인한 사용자
  const [selectedAgentDetail, setSelectedAgentDetail] = useState(null); // 선택된 에이전트 상세 정보
  const [showAllAgents, setShowAllAgents] = useState(true); // 모든 에이전트 표시 여부

  // 에이전트 수정 모달 상태
  const [openUpdateModal, setOpenUpdateModal] = useState(false);
  const [selectedUpdateAgentId, setSelectedUpdateAgentId] = useState('');
  const [updateFormValues, setUpdateFormValues] = useState({
    agent_srl: '',
    parents_agent: '',
    upperAgent: 'admin',
    id: '',
    prefix: '',
    fee: 0,
    created_at: '',
    vendor_set: '',
  });
  const [updateError, setUpdateError] = useState('');
  const [updateSuccess, setUpdateSuccess] = useState('');
  const [updateLoading, setUpdateLoading] = useState(false);
  const [updateParentFee, setUpdateParentFee] = useState(0);

  // 현재 로그인한 사용자 정보 가져오기
  const getUser = () => {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  };

  const handleMenuOpen = (event, rowId) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowId(rowId);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRowId(null);
  };

  const handleMenuItemClick = action => {
    if (action === 'edit') {
      setSelectedUpdateAgentId(selectedRowId);
      setOpenUpdateModal(true);
      handleMenuClose();
      // 에이전트 정보 불러오기
      fetchAgentInfoForUpdate(selectedRowId);
    }

    if (action === 'history') {
      navigate(`/money-send-history?agentId=${selectedRowId}`);
    }

    if (action === 'charge') {
      navigate(`/money-charge-history?agentId=${selectedRowId}`);
    }

    if (action === 'user') {
      navigate(`/user-list?agentId=${selectedRowId}`);
    }

    if (action === 'payment') {
      navigate(`/money?agentId=${selectedRowId}`);
    }
  };

  // 에이전트 정보 불러오기 함수 (수정용)
  const fetchAgentInfoForUpdate = async (agentId) => {
    setUpdateLoading(true);
    try {
      const response = await axios.get(`/agent/info/${agentId}`);
      if (response.data.success && response.data.agent) {
        const agent = response.data.agent;
        setUpdateFormValues({
          agent_srl: agent.agent_srl || '',
          parents_agent: agent.parents_agent || '',
          upperAgent: agent.parents_agent || '',
          id: agent.id || '',
          prefix: agent.prefix || '',
          fee: agent.fee || 0,
          created_at: agent.created_at || '',
          newPassword: '', // 새 비밀번호 필드 초기화
          vendor_set: agent.vendor_set || 'off',
        });

        // 상위 에이전트 정보 가져오기
        if (agent.parents_agent) {
          try {
            const parentResponse = await axios.get(`/agent/info/${agent.parents_agent}`);
            if (parentResponse.data.success && parentResponse.data.agent) {
              const parentAgent = parentResponse.data.agent;
              setUpdateParentFee(parentAgent.fee || 0);
            }
          } catch (parentError) {
            console.error('상위 에이전트 정보 조회 실패:', parentError);
          }
        }
      }
    } catch (error) {
      console.error('에이전트 정보 조회 실패:', error);
      setUpdateError('에이전트 정보를 불러오는 중 오류가 발생했습니다.');
    } finally {
      setUpdateLoading(false);
    }
  };

  // 수정 폼 핸들러
  const handleUpdateFormChange = (field, value) => {
    setUpdateError('');
    setUpdateSuccess('');
    
    if (field === 'fee') {
      if (value === '') {
        setUpdateFormValues(prev => ({ ...prev, [field]: value }));
        setUpdateError('요율은 숫자여야 합니다.');
        return;
      }
      
      const newFee = parseFloat(value);
      if (isNaN(newFee)) {
        setUpdateError('요율은 숫자여야 합니다.');
      } else if (newFee < parseFloat(updateParentFee)) {
        setUpdateError(`하위 에이전트의 요율은 상위 에이전트의 요율(${updateParentFee})보다 작을 수 없습니다.`);
      } else {
        setUpdateError('');
      }
    }

    setUpdateFormValues(prev => ({ ...prev, [field]: value }));
  };

  // 수정 제출 핸들러
  const handleUpdateSubmit = async () => {
    const feeValue = parseFloat(updateFormValues.fee);
    const parentFeeValue = parseFloat(updateParentFee);
    
    if (feeValue < parentFeeValue) {
      setUpdateError(`하위 에이전트의 요율(${feeValue})은 상위 에이전트의 요율(${parentFeeValue})보다 작을 수 없습니다.`);
      return;
    }

    try {
      const params = {
        agent_id: updateFormValues.id,
        parents_agent: updateFormValues.parents_agent,
        fee: updateFormValues.fee,
        vendor_set: updateFormValues.vendor_set
      };

      // 새 비밀번호가 입력된 경우에만 파라미터에 추가
      if (updateFormValues.newPassword) {
        params.password = updateFormValues.newPassword;
      }

      const response = await axios.get('/agent/update', { params });

      if (response.data.success) {
        setUpdateSuccess('에이전트 수정을 완료했습니다.');
        // 1초 후 모달 닫고 데이터 새로고침
        setTimeout(() => {
          setOpenUpdateModal(false);
          window.location.reload();
        }, 1000);
      } else {
        setUpdateError(response.data.message || '에이전트 수정에 실패했습니다.');
      }
    } catch (error) {
      console.error('에이전트 수정 중 오류:', error);
      setUpdateError(error.response?.data?.message || '에이전트 수정 중 오류가 발생했습니다.');
    }
  };

  const [agentList, setAgentList] = useState([]);
  const [loading, setLoading] = useState(false); // <-- 로딩 상태 추가
  const [agents, setAgents] = useState([]); // 에이전트 목록

  // 에이전트 상세 정보 가져오기 함수
  const fetchAgentDetail = async (agentId) => {
    try {
      const response = await axios.get(`agent/info/${agentId}`);
      
      if (response.data.success) {
        return response.data.agent;
      } else {
        console.error('에이전트 상세 정보 가져오기 실패::', response.statusText);
        return null;
      }
    } catch (error) {
      console.error('에이전트 상세 정보 가져오기 중 오류 발생:', error);
      return null;
    }
  };

  // 에이전트 목록 불러오기
  useEffect(() => {
    const fetchAgentList = async () => {
      setLoading(true);
      try {
        // 현재 로그인한 사용자 정보 가져오기
        const user = getUser();
        if (user) {
          setCurrentUser(user);
        }

        const response = await axios.get('/agent/children');
        if (response.data.success) {
          setAgentList(response.data.agent_tree.children);
          
          // 현재 로그인한 에이전트와 그 하위 에이전트들 표시
          const agentTree = response.data.agent_tree;
          
          // 드롭다운에는 하위 에이전트만 표시 (자신은 제외)
          const agentOptions = agentTree.children.map(child => ({
            id: child.id,
            name: child.id,
            level: child.level,
            cur_point: child.cur_point,
            fee: child.fee,
            total_receive: child.total_receive,
            total_payout: child.total_payout,
            total_charge: child.total_charge,
            parents_agent: child.parents_agent
          }));
          
          setAgents(agentOptions);
          
          // 상위 에이전트 옵션으로는 자신과 하위 에이전트 모두 포함
          setUpperAgentOptions([
            { id: response.data.agent_tree.id, agent_srl: 0, level: 0 }, // 현재 로그인한 에이전트
            ...response.data.agent_tree.children
          ]);
          
          // 기본값으로 빈 값 설정 (전체 보기)
          setFilters(prev => ({
            ...prev,
            agentId: ''
          }));
          
          // 처음에는 모든 에이전트 표시
          setShowAllAgents(true);
        } else {
          console.error('에이전트 목록 불러오기 실패:', response.statusText);
        }
      } catch (error) {
        console.error('에이전트 목록 불러오기 중 오류 발생:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchAgentList();
  }, []);

  const handleFilterChange = (field, value) => {
    setFilters(prevFilters => ({
      ...prevFilters,
      [field]: value,
    }));
  };

  // 에이전트 변경 시 해당 에이전트의 상세 정보 가져오기
  const handleAgentChange = async (agentId) => {
    setLoading(true);
    try {
      if (!agentId) {
        // 빈 값이면 모든 에이전트 표시
        setShowAllAgents(true);
        setSelectedAgentDetail(null);
      } else {
        // 특정 에이전트가 선택되면 해당 에이전트 정보만 표시
        setShowAllAgents(false);
        
        // 먼저 기존 에이전트 목록에서 찾기
        const foundAgent = agents.find(agent => agent.id === agentId);
        
        if (foundAgent) {
          setSelectedAgentDetail(foundAgent);
        } else {
          // 목록에 없으면 API 호출해서 상세 정보 가져오기
          const agentDetail = await fetchAgentDetail(agentId);
          if (agentDetail) {
            setSelectedAgentDetail(agentDetail);
          }
        }
      }
    } catch (error) {
      console.error('에이전트 정보 가져오기 중 오류 발생:', error);
      setSelectedAgentDetail(null);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = () => {
    handleAgentChange(filters.agentId);
  };

  const [openDialog, setOpenDialog] = useState(false);
  const [formDialogValues, setDialogFormValues] = useState({
    upperAgent: '',
    id: '',
    prefix: '',
    password: '',
    confirmPassword: '',
    fee: 0,
  });

  const [showPassword, setShowPassword] = useState(false);

  // handleDialogOpen 함수 수정
  const handleDialogOpen = () => {
    // 상위 에이전트 옵션이 있는 경우 첫 번째 값 사용, 없으면 빈 값
    const defaultAgent = upperAgentOptions.length > 0 ? upperAgentOptions[0].id : '';
    
    setDialogFormValues(prev => ({
      ...prev,
      upperAgent: defaultAgent,
      id: '',
      prefix: '',
      password: '',
      confirmPassword: '',
      fee: 0,
    }));
    
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setDialogFormValues({
      upperAgent: '',
      id: '',
      prefix: '',
      password: '',
      confirmPassword: '',
      fee: 0,
    });
    setOpenDialog(false);
  };

  const handleChange = e => {
    const { name, value } = e.target;
    setDialogFormValues(prev => ({ ...prev, [name]: value }));
  };

  const handlePasswordVisibility = () => {
    setShowPassword(prev => !prev);
  };

  const handleFormSubmit = async () => {
    if (formDialogValues.password !== formDialogValues.confirmPassword) {
      alert('비밀번호가 일치하지 않습니다.');
      return;
    }
  
    const prefixRegex = /^[a-zA-Z0-9]+$/;
    if (!prefixRegex.test(formDialogValues.prefix)) {
      alert('prefix는 영문과 숫자 조합만 가능합니다.');
      return;
    }
  
    try {
      const response = await axios.post('/agent/child/register', {
        id: formDialogValues.id,
        password: formDialogValues.password,
        password_confirmation: formDialogValues.confirmPassword,
        prefix: formDialogValues.prefix,
        fee: formDialogValues.fee,
        parents_agent: formDialogValues.upperAgent // 상위 에이전트 ID
      });
  
      if (response.status === 200) {
        alert('에이전트가 성공적으로 생성되었습니다.');
        setOpenDialog(false);
        
        // 현재 페이지 새로고침해서 모든 데이터 갱신
        window.location.reload();
      } else {
        alert('에이전트 생성에 실패했습니다.');
      }
    } catch (error) {
      console.error('에이전트 생성 중 오류:', error);
      // 서버에서 반환한 오류 메시지 표시
      if (error.response && error.response.data && error.response.data.message) {
        alert(error.response.data.message);
      } else {
        alert('에이전트 생성 중 오류가 발생했습니다.');
      }
    }
  };

  const handleTreeViewClick = id => {
    navigate(`/agent/treeview/${id}`);
  };

  const [openModal, setOpenModal] = useState(false);
  const [paymentAmount, setPaymentAmount] = useState('');

  const [selectedAction, setSelectedAction] = useState(''); // '지급' or '회수'
  const [selectedAgentId, setSelectedAgentId] = useState('');

  const handlePaymentClick = (agentId, action) => {
    setSelectedAction(action); // '지급' 또는 '회수'
    setSelectedAgentId(agentId); // 어떤 에이전트인지 기억
    setPaymentAmount(''); // 초기화
    setOpenModal(true); // 모달 오픈
  };

  const handleCancel = () => {
    setOpenModal(false);
  };

  const [paymentLoading, setPaymentLoading] = useState(false);

  const handlePaymentSubmit = async () => {
    setPaymentLoading(true); // 버튼 비활성화 시작
    try {
      const endpoint = selectedAction === '지급' ? '/agent/point/add' : '/agent/point/set';
      const description = selectedAction === '지급' ? '보너스 지급' : '오류 정정';
  
      const payload = {
        agent_id: selectedAgentId,
        amount: paymentAmount,
        description,
      };
  
      const response = await axios.post(endpoint, payload);
  
      if (response.data.success) {
        alert(`${response.data.message}`);
        setPaymentAmount('');
        setOpenModal(false); // 팝업 닫기
        
        // 현재 페이지 새로고침해서 모든 데이터 갱신
        window.location.reload();
      } else {
        alert(`${selectedAction} 실패: ${response.data.message || '알 수 없는 오류'}`);
      }
    } catch (error) {
      console.error(`${selectedAction} 중 오류 발생:`, error);
      
      // 서버에서 반환한 오류 메시지 표시
      if (error.response && error.response.data) {
        if (error.response.data.message) {
          alert(`${selectedAction} 실패: ${error.response.data.message}`);
        } else if (error.response.data.error) {
          alert(`${selectedAction} 실패: ${error.response.data.error}`);
        } else {
          alert(`${selectedAction} 처리 중 오류가 발생했습니다.`);
        }
      } else {
        alert(`${selectedAction} 처리 중 서버 연결 오류가 발생했습니다.`);
      }
    } finally {
      setPaymentLoading(false); // 버튼 다시 활성화
    }
  };

  // 숫자 포맷팅 함수
  const formatNumber = (number) => {
    if (number === null || number === undefined) return '0';
    return String(number).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  // 관리자 권한 여부 확인 (수정 모달용)
  const isAdmin = currentUser && currentUser.grade === 'admin';

  return (
    <Box sx={darkModeStyles.container}>
      <Paper sx={darkModeStyles.paper}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
          <Typography variant="h4" sx={darkModeStyles.title}>
            에이전트 목록
          </Typography>
          <Button
            variant="contained"
            onClick={handleDialogOpen}
            sx={darkModeStyles.createButton}
          >
            에이전트 생성
          </Button>
        </Box>
        {/* 필터 영역 */}
        <Box display="flex" flexDirection={isNonMobile ? 'row' : 'column'} justifyContent={'flex-end'} gap={2} sx={{ mb: 2 }}>
          {currentUser && currentUser.grade === 'admin' ? (
            <TextField 
              label="에이전트 아이디" 
              value={filters.agentId} 
              onChange={e => handleFilterChange('agentId', e.target.value)} 
              sx={{ ...darkModeStyles.textField, width: '30%' }} 
            />
          ) : (
            <FormControl sx={{ ...darkModeStyles.formControl, width: '30%' }}>
              <InputLabel>에이전트 아이디</InputLabel>
              <Select 
                value={filters.agentId} 
                onChange={e => {
                  handleFilterChange('agentId', e.target.value);
                  // 에이전트 변경 시 해당 에이전트의 상세 정보 가져오기
                  handleAgentChange(e.target.value);
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      backgroundColor: 'rgba(35, 35, 50, 0.95)',
                      boxShadow: '0 8px 24px rgba(0, 0, 0, 0.3)',
                      border: '1px solid rgba(255, 255, 255, 0.1)',
                      borderRadius: '8px'
                    }
                  }
                }}
              >
                {/* 전체 보기 옵션 추가 */}
                <MenuItem value="" sx={darkModeStyles.menuItemHighlight}>
                  <Typography fontWeight="bold">전체</Typography>
                </MenuItem>

                {/* 하위 에이전트 목록 */}
                {agents.map(agent => (
                  <MenuItem
                    key={agent.id}
                    value={agent.id}
                    sx={darkModeStyles.menuItem}
                  >
                    {agent.id}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}

          <Button
            variant="contained"
            onClick={handleSearch}
            disabled={loading}
            sx={darkModeStyles.searchButton}
          >
            {loading ? <CircularProgress size={20} color="inherit" /> : <SearchIcon sx={{ fontSize: 20, mr: 1 }} />}
            {loading ? '로딩 중...' : '검색'}
          </Button>
        </Box>

        <TableContainer sx={darkModeStyles.tableContainer}>
          {loading ? (
            <Box display="flex" justifyContent="center" alignItems="center" height="200px">
              <CircularProgress sx={darkModeStyles.loadingIndicator} />
            </Box>
          ) : (
            <Table>
              <TableHead sx={darkModeStyles.tableHead}>
                <TableRow>
                  <TableCell sx={darkModeStyles.tableCell}>상위 에이전트</TableCell>
                  <TableCell sx={darkModeStyles.tableCell}>에이전트</TableCell>
                  <TableCell sx={darkModeStyles.tableCell}>관리</TableCell>
                  <TableCell sx={darkModeStyles.tableCell}>현재 보유 금액</TableCell>
                  <TableCell sx={darkModeStyles.tableCell}>요율</TableCell>
                  <TableCell sx={darkModeStyles.tableCell}>총 지급받은 금액</TableCell>
                  <TableCell sx={darkModeStyles.tableCell}>총 지급해준 금액</TableCell>
                  <TableCell sx={darkModeStyles.tableCell}>총 충전받은 금액</TableCell>
                  <TableCell sx={darkModeStyles.tableCell}>트리뷰</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {showAllAgents ? (
                  // 모든 에이전트 목록 표시
                  agentList.length > 0 ? (
                    agentList.map((row, index) => (
                      <TableRow key={index} sx={darkModeStyles.tableRow}>
                        <TableCell sx={darkModeStyles.tableCell}>{row.parents_agent}</TableCell>
                        <TableCell sx={darkModeStyles.tableCell}>
                          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <Typography variant="body1" textAlign="center" sx={{ color: '#fff' }}>
                              {row.id}
                            </Typography>
                            <Button
                              onClick={event => handleMenuOpen(event, row.id)}
                              sx={darkModeStyles.agentButton}
                              variant="outlined"
                            >
                              @{row.id}
                            </Button>
                          </Box>
                        </TableCell>
                        <TableCell sx={darkModeStyles.tableCell}>
                          <Button
                            onClick={() => handlePaymentClick(row.id, '지급')}
                            sx={darkModeStyles.addButton}
                          >
                            지급
                          </Button>
                          <Button
                            onClick={() => handlePaymentClick(row.id, '회수')}
                            sx={darkModeStyles.subtractButton}
                          >
                            회수
                          </Button>
                        </TableCell>
                        <TableCell sx={darkModeStyles.tableCell}>{formatNumber(row.cur_point)}</TableCell>
                        <TableCell sx={darkModeStyles.tableCell}>{row.fee}</TableCell>
                        <TableCell sx={darkModeStyles.tableCell}>{formatNumber(row.total_receive ?? 0)}</TableCell>
                        <TableCell sx={darkModeStyles.tableCell}>{formatNumber(row.total_payout ?? 0)}</TableCell>
                        <TableCell sx={darkModeStyles.tableCell}>{formatNumber(row.total_charge ?? 0)}</TableCell>
                        <TableCell sx={darkModeStyles.tableCell}>
                          <Button variant="contained" sx={darkModeStyles.treeViewButton} onClick={() => handleTreeViewClick(row.id)}>
                            트리뷰
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={9} align="center">
                        <Typography sx={darkModeStyles.noDataMessage}>하위 에이전트가 없습니다.</Typography>
                      </TableCell>
                    </TableRow>
                  )
                ) : (
                  // 선택된 에이전트 정보만 표시
                  selectedAgentDetail ? (
                    <TableRow sx={darkModeStyles.tableRowHighlight}>
                      <TableCell sx={darkModeStyles.tableCell}>{selectedAgentDetail.parents_agent}</TableCell>
                      <TableCell sx={darkModeStyles.tableCell}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                          <Typography variant="body1" textAlign="center" fontWeight="bold" sx={{ color: '#ce93d8' }}>
                            {selectedAgentDetail.id}
                          </Typography>
                          <Button
                            onClick={event => handleMenuOpen(event, selectedAgentDetail.id)}
                            sx={darkModeStyles.agentButton}
                            variant="outlined"
                          >
                            @{selectedAgentDetail.id}
                          </Button>
                        </Box>
                      </TableCell>
                      <TableCell sx={darkModeStyles.tableCell}>
                        <Button
                          onClick={() => handlePaymentClick(selectedAgentDetail.id, '지급')}
                          sx={darkModeStyles.addButton}
                        >
                          지급
                        </Button>
                        <Button
                          onClick={() => handlePaymentClick(selectedAgentDetail.id, '회수')}
                          sx={darkModeStyles.subtractButton}
                        >
                          회수
                        </Button>
                      </TableCell>
                      <TableCell sx={darkModeStyles.tableCell}>
                        {formatNumber(selectedAgentDetail.cur_point)}
                      </TableCell>
                      <TableCell sx={darkModeStyles.tableCell}>{selectedAgentDetail.fee}</TableCell>
                      <TableCell sx={darkModeStyles.tableCell}>{formatNumber(selectedAgentDetail.total_receive || 0)}</TableCell>
                      <TableCell sx={darkModeStyles.tableCell}>{formatNumber(selectedAgentDetail.total_payout || 0)}</TableCell>
                      <TableCell sx={darkModeStyles.tableCell}>{formatNumber(selectedAgentDetail.total_charge || 0)}</TableCell>
                      <TableCell sx={darkModeStyles.tableCell}>
                        <Button 
                          variant="contained"
                          sx={darkModeStyles.treeViewButton}
                          onClick={() => handleTreeViewClick(selectedAgentDetail.id)}
                        >
                          트리뷰
                        </Button>
                      </TableCell>
                    </TableRow>
                  ) : (
                    <TableRow>
                      <TableCell colSpan={9} align="center">
                        <Typography sx={darkModeStyles.noDataMessage}>선택된 에이전트 정보가 없습니다.</Typography>
                      </TableCell>
                    </TableRow>
                  )
                )}
              </TableBody>
            </Table>
          )}
        </TableContainer>
      </Paper>

      {/* 에이전트 생성 다이얼로그 */}
      <Dialog open={openDialog} onClose={handleDialogClose} maxWidth="sm" fullWidth sx={darkModeStyles.dialog}>
        <DialogTitle sx={darkModeStyles.dialogTitle}>에이전트 생성</DialogTitle>
        <DialogContent sx={darkModeStyles.dialogContent}>
          <TextField
            label="상부 에이전트"
            name="upperAgent"
            value={formDialogValues.upperAgent}
            onChange={handleChange}
            fullWidth
            margin="dense"
            select
            sx={darkModeStyles.textField}
          >
            {upperAgentOptions.map((option) => (
              <MenuItem 
                key={option.id} 
                value={option.id}
                sx={option.level === 0 ? darkModeStyles.menuItemHighlight : darkModeStyles.menuItem}
              >
                {option.id}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            label="아이디"
            name="id"
            value={formDialogValues.id}
            onChange={handleChange}
            fullWidth
            margin="dense"
            required
            helperText={!formDialogValues.id && '필수값 입니다.'}
            error={!formDialogValues.id}
            inputProps={{ maxLength: 30 }}
            sx={darkModeStyles.textField}
          />

          <TextField
            label="prefix"
            name="prefix"
            value={formDialogValues.prefix}
            onChange={handleChange}
            fullWidth
            margin="dense"
            required
            helperText={!formDialogValues.prefix && '필수값 입니다. 영문, 숫자 조합만 가능합니다.'}
            error={!formDialogValues.prefix}
            inputProps={{ maxLength: 3 }}
            sx={darkModeStyles.textField}
          />

          <TextField
            label="비밀번호"
            name="password"
            type={showPassword ? 'text' : 'password'}
            value={formDialogValues.password}
            onChange={handleChange}
            fullWidth
            margin="dense"
            required
            inputProps={{ minLength: 6 }}
            helperText={
              !formDialogValues.password ? '필수값 입니다.' : formDialogValues.password.length < 6 ? '비밀번호는 최소 6자리 이상 입력해주세요.' : ''
            }
            error={!formDialogValues.password}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handlePasswordVisibility} sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            sx={darkModeStyles.textField}
          />

          <TextField
            label="비밀번호 확인"
            name="confirmPassword"
            type={showPassword ? 'text' : 'password'}
            value={formDialogValues.confirmPassword}
            onChange={handleChange}
            fullWidth
            margin="dense"
            required
            inputProps={{ minLength: 6 }}
            helperText={formDialogValues.password !== formDialogValues.confirmPassword && '비밀번호가 일치하지 않습니다.'}
            error={formDialogValues.password !== formDialogValues.confirmPassword}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handlePasswordVisibility} sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            sx={darkModeStyles.textField}
          />
          <TextField
            label="요율"
            name="fee"
            value={formDialogValues.fee}
            onChange={e => {
              const { name, value } = e.target;
              // 숫자 또는 소수점만 허용
              if (/^[0-9]*\.?[0-9]*$/.test(value)) {
                setDialogFormValues(prev => ({
                  ...prev,
                  [name]: value,
                }));
              }
            }}
            onFocus={(e) => {
              if (e.target.value === '0') {
                setDialogFormValues(prev => ({
                  ...prev,
                  fee: ''
                }));
              }
            }}
            onBlur={(e) => {
              if (e.target.value === '') {
                setDialogFormValues(prev => ({
                  ...prev,
                  fee: '0'
                }));
              }
            }}
            fullWidth
            margin="dense"
            inputProps={{ maxLength: 10 }}
            sx={darkModeStyles.textField}
          />
        </DialogContent>
        <DialogActions sx={darkModeStyles.dialogActions}>
          <Button onClick={handleDialogClose} sx={darkModeStyles.cancelButton} variant="outlined">
            취소
          </Button>
          <Button
            variant="contained"
            onClick={handleFormSubmit}
            disabled={
              !formDialogValues.id ||
              !formDialogValues.prefix ||
              !formDialogValues.password ||
              formDialogValues.password.length < 6 ||
              !formDialogValues.confirmPassword
            }
            sx={darkModeStyles.submitButton}
          >
            생성
          </Button>
        </DialogActions>
      </Dialog>

      {/* 에이전트 수정 모달 */}
      <Dialog 
        open={openUpdateModal} 
        onClose={() => setOpenUpdateModal(false)} 
        maxWidth="sm" 
        fullWidth 
        sx={darkModeStyles.dialog}
        PaperProps={{
          sx: {
            position: 'absolute',
            top: '5%',
            margin: 0,
            maxHeight: '90%',
            overflow: 'visible'
          }
        }}
      >
        <DialogTitle sx={darkModeStyles.dialogTitle}>
          에이전트 수정 - {selectedUpdateAgentId}
        </DialogTitle>
        <DialogContent sx={darkModeStyles.dialogContent}>
          {updateLoading ? (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="300px">
              <CircularProgress sx={darkModeStyles.loadingIndicator} />
            </Box>
          ) : (
            <>
              {updateError && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  {updateError}
                </Alert>
              )}
              
              {updateSuccess && (
                <Alert severity="success" sx={{ mb: 2 }}>
                  {updateSuccess}
                </Alert>
              )}
              
              <Box display="flex" flexDirection="column" gap={3}>
                <TextField
                  label="상위 에이전트"
                  value={updateFormValues.upperAgent}
                  disabled
                  fullWidth
                  sx={darkModeStyles.textField}
                />
                
                <TextField
                  label="아이디"
                  value={updateFormValues.id}
                  disabled
                  fullWidth
                  sx={darkModeStyles.textField}
                />
                
                <TextField
                  label="고유코드"
                  value={updateFormValues.prefix}
                  disabled
                  fullWidth
                  sx={darkModeStyles.textField}
                />
                
                {/* 비밀번호 입력 필드 - 어드민만 볼 수 있음 */}
                {isAdmin && (
                  <TextField
                    label="비밀번호"
                    value={updateFormValues.newPassword || ''}
                    onChange={e => handleUpdateFormChange('newPassword', e.target.value)}
                    type={showPassword ? 'text' : 'password'}
                    fullWidth
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={() => setShowPassword(!showPassword)} sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    helperText={
                      <span style={{ color: '#e0e0e0', fontSize: '14px' }}>
                        새 비밀번호를 입력하세요 (공백으로 두면 변경하지 않음)
                      </span>
                    }
                    sx={darkModeStyles.textField}
                  />
                )}
                
                <TextField
                  label="요율"
                  value={updateFormValues.fee}
                  onChange={e => handleUpdateFormChange('fee', e.target.value)}
                  fullWidth
                  helperText={
                    <span style={{ color: '#e0e0e0', fontSize: '14px' }}>
                      상위 에이전트 요율: {updateParentFee}% (요율은 상위 에이전트보다 작을 수 없습니다)
                    </span>
                  }
                  error={parseFloat(updateFormValues.fee) < parseFloat(updateParentFee)}
                  sx={darkModeStyles.textField}
                />
                
                {isAdmin && (
                  <FormControl fullWidth sx={darkModeStyles.formControl}>
                    <InputLabel id="vendor-set-label">벤더 설정</InputLabel>
                    <Select
                      labelId="vendor-set-label"
                      value={updateFormValues.vendor_set}
                      label="벤더 설정"
                      onChange={e => handleUpdateFormChange('vendor_set', e.target.value)}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            backgroundColor: 'rgba(35, 35, 50, 0.95)',
                            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.3)',
                            border: '1px solid rgba(255, 255, 255, 0.1)',
                            borderRadius: '8px'
                          }
                        }
                      }}
                    >
                      <MenuItem value="on" sx={darkModeStyles.menuItem}>활성화</MenuItem>
                      <MenuItem value="off" sx={darkModeStyles.menuItem}>비활성화</MenuItem>
                    </Select>
                  </FormControl>
                )}
                
                <TextField
                  label="가입 시각"
                  value={updateFormValues.created_at}
                  disabled
                  fullWidth
                  sx={darkModeStyles.textField}
                />
              </Box>
            </>
          )}
        </DialogContent>
        <DialogActions sx={darkModeStyles.dialogActions}>
          <Button 
            onClick={() => setOpenUpdateModal(false)} 
            sx={darkModeStyles.cancelButton} 
            variant="outlined"
          >
            취소
          </Button>
          <Button
            onClick={handleUpdateSubmit}
            variant="contained"
            disabled={parseFloat(updateFormValues.fee) < parseFloat(updateParentFee) || updateLoading}
            sx={darkModeStyles.submitButton}
          >
            {updateLoading ? '처리 중...' : '수정'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* 메뉴 */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        sx={darkModeStyles.menu}
      >
        <MenuItem onClick={() => handleMenuItemClick('edit')}>수정</MenuItem>
        <Box sx={darkModeStyles.menuDivider}>
          <Typography variant="subtitle2" sx={darkModeStyles.menuHeader}>
            유저
          </Typography>
          <MenuItem onClick={() => handleMenuItemClick('user')}>유저 목록</MenuItem>
          <MenuItem onClick={() => handleMenuItemClick('payment')}>지급 내역</MenuItem>
        </Box>
      </Menu>

      {/* 지급/회수 모달 */}
      <Modal open={openModal} onClose={handleCancel}>
        <Box sx={darkModeStyles.modal}>
          <Typography variant="h6" sx={darkModeStyles.modalTitle}>
            {selectedAction} 처리
          </Typography>
          <TextField
            label={`${selectedAction} 금액`}
            value={paymentAmount}
            onChange={e => {
              const { value } = e.target;
              // 숫자 또는 소수점만 허용
              if (/^[0-9]*\.?[0-9]*$/.test(value)) {
                setPaymentAmount(value);
              }
            }}
            fullWidth
            sx={{ ...darkModeStyles.textField, mb: 1 }}
            inputProps={{ maxLength: 30 }}
          />
          
          {/* 빠른 금액 버튼 추가 */}
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
            <Button 
              variant="contained" 
              onClick={() => setPaymentAmount('50000000')} 
              sx={darkModeStyles.quickAmountButton}
            >
              5천
            </Button>
            <Button 
              variant="contained" 
              onClick={() => setPaymentAmount('100000000')} 
              sx={darkModeStyles.quickAmountButton}
            >
              1억
            </Button>
            <Button 
              variant="contained" 
              onClick={() => setPaymentAmount('300000000')} 
              sx={darkModeStyles.quickAmountButton}
            >
              3억
            </Button>
            <Button 
              variant="contained" 
              onClick={() => setPaymentAmount('500000000')} 
              sx={darkModeStyles.quickAmountButton}
            >
              5억
            </Button>
          </Box>
          
          <Typography variant="body2" color="error" sx={{ mb: 2, px: 1 }}>
            에이전트 보유 금액보다 큰 금액을 지급할 수 없습니다. <br />
            대상 유저의 보유 금액보다 큰 금액을 차감할 수 없습니다.
          </Typography>
          <Box display="flex" justifyContent="flex-end" gap={2}>
            <Button variant="outlined" onClick={handleCancel} sx={darkModeStyles.cancelButton}>
              취소
            </Button>

            <Button 
              variant="contained" 
              onClick={handlePaymentSubmit} 
              disabled={paymentLoading}
              sx={darkModeStyles.submitButton}
            >
              {paymentLoading ? '처리 중...' : selectedAction || '지급'}
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default AgentList;